import { render, staticRenderFns } from "./businessRelation.vue?vue&type=template&id=5ef4087a&scoped=true"
import script from "./businessRelation.vue?vue&type=script&lang=js"
export * from "./businessRelation.vue?vue&type=script&lang=js"
import style0 from "./businessRelation.vue?vue&type=style&index=0&id=5ef4087a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef4087a",
  null
  
)

export default component.exports